/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_SubtitleInputs */

const en_signup_subtitle = /** @type {(inputs: Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start your free trial today`)
};

const fr_signup_subtitle = /** @type {(inputs: Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencez votre essai gratuit aujourd'hui`)
};

const de_signup_subtitle = /** @type {(inputs: Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starten Sie noch heute Ihre kostenlose Testphase.`)
};

const it_signup_subtitle = /** @type {(inputs: Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia oggi la tua prova gratuita`)
};

const ru_signup_subtitle = /** @type {(inputs: Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начните бесплатную пробную версию сегодня!`)
};

const es_signup_subtitle = /** @type {(inputs: Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comience su prueba gratuita hoy`)
};

const zh_cn2_signup_subtitle = /** @type {(inputs: Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即开始免费试用`)
};

const ja_signup_subtitle = /** @type {(inputs: Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐ無料トライアルを始めましょう`)
};

const hi_signup_subtitle = /** @type {(inputs: Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपना मुफ्त ट्रायल आज ही शुरू करें`)
};

const pt_pt2_signup_subtitle = /** @type {(inputs: Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece seu teste gratuito hoje mesmo`)
};

/**
* | output |
* | --- |
* | "Start your free trial today" |
*
* @param {Signup_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_subtitle = /** @type {((inputs?: Signup_SubtitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_SubtitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_subtitle(inputs)
	if (locale === "de") return de_signup_subtitle(inputs)
	if (locale === "it") return it_signup_subtitle(inputs)
	if (locale === "ru") return ru_signup_subtitle(inputs)
	if (locale === "es") return es_signup_subtitle(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_subtitle(inputs)
	if (locale === "ja") return ja_signup_subtitle(inputs)
	if (locale === "hi") return hi_signup_subtitle(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_subtitle(inputs)
	return en_signup_subtitle(inputs)
});